import { ServiceVariation } from "@/services/backend/omni/servicevariation/types/service-variation";
import { UUID } from "@bitory-gmbh/nidavellir";
import { PaymentTerms } from "@/services/backend/billing/types/payment-terms";
import { Information } from "@/services/backend/billing/types/information";

/** Mirrors `contract.DefaultBaseDataKey`, backend/core/omni/domain/contract/base_data.go. */
export function omniContractBaseDataKey(serviceKind: string): string {
  return `omni.contract.baseData.${serviceKind}`;
}

/** Mirrors `contract.BaseData`, backend/core/omni/domain/contract/base_data.go. */
export type ContractBaseData = {
  id: UUID;
  companyId: UUID;
  label: string;
  createdAt: string;
  updatedAt: string;
  serviceKind: string;
  serviceVariation: ServiceVariation;
  title: string;
  subtitle: string;
  text: string;
  paymentTerms: PaymentTerms;
  billingInformation: Information;
};

/** Mirrors `contract.BaseDataPatch`, backend/core/omni/domain/contract/base_data.go. */
export type ContractBaseDataPatch = {
  label?: string;
  serviceVariation?: ServiceVariation;
  title?: string;
  subtitle?: string;
  text?: string;
  paymentTerms?: PaymentTerms;
  billingInformation?: Information;
};

export function patchContractBaseData(
  baseData: ContractBaseData,
  patch: ContractBaseDataPatch,
): ContractBaseData {
  return { ...baseData, ...patch };
}
